// initial state
import * as base from './base.js'
const baseName = '/admin/system/version'


const versionList = baseName + '/list'
const versionAdd = baseName + '/add'
const versionEdit = baseName + '/edit'



const obj = base.setBaseUrl('', baseName)
const obj1 = base.setBaseUrl('list',versionList )
const obj2 = base.setBaseUrl('add',versionAdd )
const obj3 = base.setBaseUrl('edit',versionEdit )



const a = Object.assign(obj,obj1,obj2,obj3, { baseName,versionList,versionAdd,versionEdit })
export default a